import styled from 'styled-components';
import Markdown from 'markdown-to-jsx';

export const Wrap = styled.div`
    + div {
        padding-top: ${({ theme }) => theme.spacers.L};
    }

    z-index: 3;
    position: relative;
    display: flex;
    padding: ${({ theme }) => theme.spacers.M};
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${({ theme }) => theme.colors.Color1};

    * {
        color: #fff;
        fill: #fff;
    }

    a {
        text-decoration: underline;

        &:hover,
        &:focus {
            color: #fff;
        }
    }
`;

export const BannerText = styled(Markdown)`
    ${({ theme }) => theme.typography.TinyParagraph};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CloseButton = styled.button`
    display: flex;
    margin: 0 ${({ theme }) => theme.spacers.L};
    padding: 0;
    cursor: pointer;
    border: none;
    appearance: none;
    background: none;
`;
